import { Modal } from "antd"
import React from "react"

interface UnlinkAllToAllModalProps {
    open: boolean
    loading?: boolean
    valuesNames: string[]
    onConfirm: () => void
    onClose: () => void
}

const UnlinkAllToAllModal: React.FC<UnlinkAllToAllModalProps> = ({
    open,
    loading,
    valuesNames,
    onConfirm,
    onClose,
}) => {
    return (
        <Modal
            open={open}
            title="Отвязать всё от всего"
            okText="Отвязать"
            cancelText="Отмена"
            okButtonProps={{
                danger: true,
                loading,
            }}
            onOk={onConfirm}
            onCancel={onClose}
            closable={!loading}
            maskClosable={!loading}
        >
            <p>
                Будут удалены все сочетания свойств для выбранных значений:
            </p>

            <ul>
                {valuesNames.map((value) => (
                    <li key={value}>{value}</li>
                ))}
            </ul>
        </Modal>
    )
}

export default UnlinkAllToAllModal